// extracted by mini-css-extract-plugin
export default {"container":"departments_container__XkV8x","skeleton":"departments_skeleton__1zmhv","warning_banner":"departments_warning_banner__sRqyZ"};